module.exports = __webpack_public_path__ + "src/assets/images/loading-gif-png-5.e4b6323e19e57f6761b1ce47b7d329e0.gif";